import { Link } from "react-router-dom";
import heroBg from "./images/Hero1.jpg"; // Ensure this path matches your actual file

export default function Hero() {
  return (
    <div
      className="relative w-full h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <h1 className="text-4xl md:text-6xl  font-extrabold text-orange-500 drop-shadow-lg">
          iNVORA TECHNOLOGY
        </h1>
        <p className="mt-4 text-lg md:text-xl text-white drop-shadow-md">
          Setting the Standard in an Engineering Design.
        </p>
        <Link
          to="/About"
          className="mt-6 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl shadow-lg transition duration-300"
        >
          Explore Now
        </Link>
      </div>
    </div>
  );
}
